import { useState, FunctionComponent } from 'react';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { INFO } from "../../assets/Icons";

export class InfoBoxProps {
  helpText: string;
  style: any;
}

export const InfoBox: FunctionComponent<InfoBoxProps> = ({ helpText, style }) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        PopperProps={{
          disablePortal: false,
          sx: { zIndex: 9999 },
          modifiers: [{ name: "offset", options: { offset: [0, -10] } }]
        }}
        enterTouchDelay={0} leaveTouchDelay={3000}
        onClose={handleTooltipClose}
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        arrow
        title={<div style={{ width: 200, whiteSpace: 'normal', textAlign: 'left' }}>
          {helpText}
        </div>}
        sx={{ mt: 0 }}>
        <IconButton style={style} tabIndex={-1} sx={{ p: 0.5, ml: 0.5 }} color="primary" type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleTooltipOpen(); }}>{INFO(20)}</IconButton>
      </Tooltip>
    </ClickAwayListener>
  )
}